import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import Badge from '@material-ui/core/Badge';
import { makeStyles } from '@material-ui/core/styles';

import { useProjectPageRedesign } from 'components/ProjectPageRedesign/ProjectPageRedesignContext';
import { getProjectPageRedesignColors } from 'components/ProjectPageRedesign/projectPageRedesignColors';

const useStyles = makeStyles((theme) => ({
  badge: {
    ...theme.component.sideBadge,
    color: 'white',
    right: -3,
    top: 13,
    padding: '0 4px',
  },
}));

// On the redesigned projects page (ProjectPageRedesignContext) the badge sits
// on the project bank's card surface, so its ring, which cuts the badge out
// of the surface under it, takes that colour.
const useRedesignStyles = makeStyles(
  (theme) => ({
    badge: {
      borderColor: getProjectPageRedesignColors(theme).card,
    },
  }),
  { name: 'LixProjectPageRedesignSideBadge' }
);

function SideBadge(props) {
  const { children, ...badgeProps } = props;
  const classes = useStyles();
  const redesign = useProjectPageRedesign();
  const redesignClasses = useRedesignStyles();

  return (
    <Badge
      classes={{
        badge: clsx(classes.badge, redesign && redesignClasses.badge),
      }}
      {...badgeProps}
      overlap="rectangular"
    >
      {children}
    </Badge>
  );
}

SideBadge.propTypes = {
  children: PropTypes.node,
};

export default SideBadge;
